import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { useAdminData } from '../../../../../hooks/useAdminData';
import { QAComponentInterface } from '../../../../../interfaces/pagebuilder';
import { fetchAndSetEvent } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../reduxToolkit/typedRedux';
import VyButton from '../../../../common/VyButton';
import QAControlModal from '../../../QAControlModal';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface QASettingsTableInterface {
  component: QAComponentInterface;
  onChange: (c: QAComponentInterface) => void;
}

const QASettingsTable = ({ component, onChange }: QASettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);
  const dispatch = useDispatch();
  const { updateEventProperty } = useAdminData(false);

  const event = useSelector((state) => state.common.event);

  const [isControlOpen, setIsControlOpen] = useState(false);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          content: <VyButton onClick={() => setIsControlOpen(true)}>{t('pagebuilder:open-qa-control')}</VyButton>,
        },
        {
          tooltip: t('pagebuilder:qa-settings.tooltip-label'),
          path: 'label',
          type: 'text',
          label: t('pagebuilder:qa-settings.label'),
        },
        {
          tooltip: t('pagebuilder:qa-settings.tooltip-delay'),
          label: t('pagebuilder:qa-settings.delay'),
          type: 'number',
          path: 'delay',
        },
        {
          tooltip: t('pagebuilder:qa-settings.tooltip-max-length'),
          label: t('pagebuilder:qa-settings.max-length'),
          type: 'number',
          conditions: {
            max: { value: 10000, message: t('config:errors.maximum-value', { value: 10000 }) },
            min: { value: 200, message: t('config:errors.minimum-value', { value: 200 }) },
          },
          path: 'maxLength',
        },
        {
          label: t('config:privateModeQA-title'),
          tooltip: t('config:privateModeQA-description'),
          defaultValue: event?.settings?.privateModeQA,
          disabled: !event,
          type: 'boolean',
          onChange: async () => {
            await updateEventProperty(!event?.settings?.privateModeQA, 'settings.privateModeQA');
            dispatch(fetchAndSetEvent({ eventid: event!._id }));
          },
        },
      ],
    },
  ];

  return (
    <>
      <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />
      {isControlOpen && <QAControlModal open={true} onClose={() => setIsControlOpen(false)} />}
    </>
  );
};
export default QASettingsTable;
